export default __webpack_public_path__ + "static/media/M18.7a65119e.jpg";